/**
 * Global Search Configuration
 *
 * Defines default behaviors and settings for search functionality across the application.
 */
export const globalSearchConfig = {
    debounceMs: 300,
    minSearchLength: 2,
    maxResults: 100,
    defaultLimit: 100,
    enableHighlighting: true,
    caseSensitive: false,
    multiTermSearch: true,
    highlightStyle: {
        className: 'search-highlight',
        // Default inline style as fallback if className is not defined in CSS
        style: {
            backgroundColor: 'yellow',
            color: 'black',
            fontWeight: 'bold',
            padding: '0 2px',
            borderRadius: '2px',
        }
    }
};
